import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { 
    ReportInput, 
    ChartInput, 
    DashboardInput,
    TabGroupInput,
    FormInput
} from '@bi-studio/shared/lib';
import { RootState } from '../index';

interface DraftState {
    report: Partial<ReportInput> | null;
    chart: Partial<ChartInput> | null;
    dashboard: Partial<DashboardInput> | null;
    tabGroup: Partial<TabGroupInput> | null;
    form: Partial<FormInput> | null;
}

const initialState: DraftState = {
    report: null,
    chart: null,
    dashboard: null,
    tabGroup: null,
    form: null,
};

export const draftSlice = createSlice({
    name: 'draft',
    initialState,
    reducers: {
        setReportDraft: (state, action: PayloadAction<Partial<ReportInput> | null>) => {
            state.report = action.payload;
        },
        setChartDraft: (state, action: PayloadAction<Partial<ChartInput> | null>) => {
            state.chart = action.payload;
        },
        setDashboardDraft: (state, action: PayloadAction<Partial<DashboardInput> | null>) => {
            state.dashboard = action.payload;
        },
        setTabGroupDraft: (state, action: PayloadAction<Partial<TabGroupInput> | null>) => {
            state.tabGroup = action.payload;
        },
        setFormDraft: (state, action: PayloadAction<Partial<FormInput> | null>) => {
            state.form = action.payload;
        },
        clearDrafts: () => initialState,
    },
});

export const { 
    setReportDraft, 
    setChartDraft, 
    setDashboardDraft, 
    setTabGroupDraft, 
    setFormDraft,
    clearDrafts 
} = draftSlice.actions;

export const selectReportDraft = (state: RootState) => state.draft.report;
export const selectChartDraft = (state: RootState) => state.draft.chart;
export const selectDashboardDraft = (state: RootState) => state.draft.dashboard;
export const selectTabGroupDraft = (state: RootState) => state.draft.tabGroup;
export const selectFormDraft = (state: RootState) => state.draft.form;

export default draftSlice.reducer;
